import { AuthConfig } from '@spartacus/core';

export const authConfig: AuthConfig = {
  authentication: {
    revokeEndpoint: '/oauth2/logout',
  },
};
